module.exports = __webpack_public_path__ + "e8186ef773c624d7af4e8364b46db93f.png";